import { Button, ButtonColorEnum, ButtonSizeEnum, EmptyState } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { routerManager } from '@/routes/app-routes';
import { MediaManagerRouteEnum } from '@/routes/constants/MediaManagerRouteEnum';

type EmptyStateVariants = 'home' | 'reload';

interface EmptyStateErrorUnexpectedProps {
  title?: string;
  subtitle?: string;
  action?: string;
  variant?: EmptyStateVariants;
}

export function EmptyStateErrorUnexpected({
  title,
  subtitle,
  action,
  variant = 'reload',
}: EmptyStateErrorUnexpectedProps) {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={title || t('¡Vaya!, Se ha producido un error inesperado')}
      subtitle={
        subtitle || variant === 'home'
          ? t('Prueba a empezar de nuevo')
          : t('Prueba a recargar la página')
      }
    >
      <Button
        color={ButtonColorEnum.SECONDARY_OLD}
        size={ButtonSizeEnum.SM}
        onClick={() =>
          variant === 'home'
            ? routerManager.to(MediaManagerRouteEnum.MEDIA_MANAGER)
            : window.location.reload()
        }
      >
        {action || variant === 'home' ? t('Volver al inicio') : t('Actualizar página')}
      </Button>
    </EmptyState>
  );
}
